import React, { useEffect, useState } from 'react';
import ProcessIndicator from './ProcessIndicator';
import { CompanyDetailsProgresses } from 'assets/helperdata/client/company-details-progress';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import Select from 'react-select';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Skeleton } from '@mui/material';
import { FaSpinner } from 'react-icons/fa';

import { useLanguage } from '../../../contexts/LanguageContext';

// ✅ Clear
const CompanyDetails = () => {
	const history = useNavigate();
	const [isInProgress, setIsInProgress] = useState(false);
	const [isPageLoading, setIsPageLoading] = useState(true);
	const [turnOver, setTurnOver] = useState([]);
	const [activities, setActivities] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const clientUser = useSelector((state) => state.main.client);
	const [data, setData] = useState({
		companyName: clientUser?.data?.company_name,
		establishmentYear: '',
		companyActivites: '',
		companyTurnOver: '',
		id: clientUser?.data?.id,
		contactPerson: '',
		email: '',
		phone: '',
		whatsapp: '',
		website: '',
		phonecode: '',
		phonecountryiso2: '',
		whatsappcountryiso2: '',
		whatsappcode: '',
		interests: [],
		specifications: [],
		isDefaut: false
	});

	const [phoneNumber, setPhoneNumber] = useState('');
	const [isFormProcessing, setIsFormProcessing] = useState(false);

	const [whatsapp, setWhatsapp] = useState('');
	const [selectedCountry, setSelectedCountry] = useState('AE');
	const [selectedWhatsappCountry, setSelectedWhatsappCountry] = useState('AE');
	const [trigger, setTrigger] = useState(false);

	const currentYear = new Date().getFullYear();
	const establishmentYearOptions = [];
	const { t } = useLanguage()

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	for (let year = currentYear; year >= 1999; year--) {
		establishmentYearOptions.push({
			value: year.toString(),
			label: year.toString()
		});
	}
	establishmentYearOptions.push({
		value: 'Before 1999',
		label: 'Before 1999'
	});

	useEffect(() => {

		api.getTurnOvers().then((res) => {
			if (res.data) {
				setData({ ...data, companyTurnOver: res.data[0].id });
				setTurnOver(res.data);
			}
		});
		api.company_activities().then((res) => {
			if (res.data) {
				const activities = res.data.map((activity) => ({
					value: activity.id,
					label: activity.name
				}));
				setActivities(activities);
			}
		});
		if (clientUser?.data?.id) {
			api.getClientInformation(clientUser?.data?.id).then((res) => {
				setIsPageLoading(false);
				if (res.data.companyInfo) {
					if (clientUser?.data?.is_approved != 2) {
						
						setData({
							establishmentYear: res.data.companyInfo.establishment_year,
							companyActivites: res.data.companyInfo.company_activity_id,
							companyTurnOver: res.data.companyInfo.turnover_id,
							id: res.data.client.id,
							contactPerson: res.data.companyContact?.contact_person,
							email: res.data.companyContact?.email,
							phone: res.data.companyContact?.phone_number,
							whatsapp: res.data.companyContact?.whatsapp,
							phonecode: res.data.companyContact?.phone_code,
							whatsappcode: res.data.companyContact?.whatsapp_code,
							phonecountryiso2: res.data.companyContact?.phone_country_iso2,
							whatsappcountryiso2: res.data.companyContact?.whatsapp_country_iso2,
							website: res.data.companyContact?.website,
							interests: res.data.companyInterest,
							specifications: res.data.companySpec,
							isDefaut: res.data.companyContact?.isDefault === 1 ? true : false
						});
					}
				}
			});
		}
	}, []);

	useEffect(() => {
		api.getCountryList().then((res) => {
			if (res.status === true) {
				setCountryList(res.data);
			}
		});
		if (data.phonecountryiso2) {
			setSelectedCountry(data.phonecountryiso2);
		}
		if (data.whatsappcountryiso2) {
			setSelectedWhatsappCountry(data.whatsappcountryiso2);
		}
	}, []);

	useEffect(() => {
		if (data?.phonecode) {
			const country = countryList.find((country) => country.phonecode === data.phonecode);

			if (country) {
				setSelectedCountry(country.iso2);
			}
		}
	}, [data.phonecode]);

	useEffect(() => {
		if (data?.whatsappcode) {
			const country = countryList.find((country) => country.phonecode === data.whatsappcode);
			if (country) {
				setSelectedWhatsappCountry(country.iso2);
			}
		}
	}, [data.whatsappcode]);

	const changeSelectedCountry = (phoneCode) => {
	};

	const validateEmail = (email) => {
		// Simple email regex
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};

	useEffect(() => {
		if (trigger === true) {
			if (
				data.contactPerson == '' ||
				data.email == '' ||
				data.phone == '' ||
				data.whatsapp == '' ||
				data.phonecode == '' ||
				data.whatsappcode == ''
			) {
				setIsFormProcessing(false)
				setTrigger(false);
				toast.error('Please fill all fields');
			} else if (!validateEmail(data.email)) {
				setIsFormProcessing(false)
				setTrigger(false);
				toast.error('Please enter a valid email address');
			} else {
				moveToNext();
			}

		}
	}, [trigger]); // Change dependency to trigger

	const savePhones = () => {
		if (phoneNumber) {
			const phoneCode = phoneNumber.countryCallingCode;
			const phone = phoneNumber.nationalNumber;
			const phoneCountryIso2 = phoneNumber.country;
			setData((prevData) => ({ ...prevData, phone: phone, phonecode: phoneCode, phonecountryiso2: phoneCountryIso2 }));
		}
		if (whatsapp) {
			const whatsappCode = whatsapp.countryCallingCode;
			const whatsappNumber = whatsapp.nationalNumber;
			const whatsappCountryIso2 = whatsapp.country;
			setData((prevData) => ({
				...prevData,
				whatsapp: whatsappNumber,
				whatsappcode: whatsappCode,
				whatsappcountryiso2: whatsappCountryIso2
			}));
		}
		setTrigger(!trigger); // Toggle trigger state here
	};

	const moveToNext = () => {
		if (!data.establishmentYear) {
			toast.error('Please select establishment year');
			return;
		}
		if (!data.companyActivites) {
			toast.error('Please select company activities');
			return;
		}
		if (!data.companyTurnOver) {
			toast.error('Please select company turnover');
			return;
		}
		if (
			data.contactPerson == '' ||
			data.email == '' ||
			data.phone == '' ||
			data.whatsapp == '' ||
			data.phonecode == '' ||
			data.whatsappcode == ''
			// data.website == ''
		) {
			toast.error('Please fill all fields');
			setIsInProgress(false);
			setTrigger(false);
			return;
		}

		setIsFormProcessing(true)
		api
			.updateClientInfo(data.id, data)
			.then((res) => {
				setIsFormProcessing(false)
				history('/client/company-address');
				setIsInProgress(false);
			})
			.catch((err) => {
				setIsFormProcessing(false)
				setIsInProgress(false);
			});
	};

	const calculateCompletionPercentage = () => {
		const fields = ['establishmentYear', 'companyActivites', 'companyTurnOver', 'contactPerson', 'email', 'phone', 'whatsapp'];
		const filledFields = fields.filter((field) => data[field] !== undefined && data[field] !== null && data[field] !== '');
		return (filledFields.length / fields.length) * 100;
	};

	// Call this function whenever you want to get the completion percentage
	const completionPercentage = calculateCompletionPercentage();


	return (
		<div className={`main-page-client ${isMobile ? 'padding-mobile-client' : ''}`} style={{ paddingTop: 0, marginBottom: '60px' }}>
			<>
				<div className="actions-company-details-client">
					<ProcessIndicator
						isInProgress={isInProgress}
						processes={CompanyDetailsProgresses}
						currentIndex={1}
						completionPercentage={completionPercentage}
					/>
				</div>
				<div className="company-details-client-content">
					<div className="" style={{ justifyContent: 'space-between' }}>
						<table className="projectmix-table-vertical-client">
							<tbody>
								<tr>
									{!isMobile && <th></th>}

									<td className="fw-600" style={{ textAlign: isMobile ? 'left' : 'left', fontSize: isMobile ? 16 : 14 }}>
										{t('company-detail.company-detail')}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('company-detail.name')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('company-detail.name')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<input type="text" className="form-control" placeholder="company name" value={data.companyName} disabled />
											)
										}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('company-detail.establishment-year')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('company-detail.establishment-year')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<Select
													className="rs-container-est-white-client"
													classNamePrefix="rs"
													isSearchable={true}
													name="customer"
													options={establishmentYearOptions}
													value={establishmentYearOptions
														.map((y) => ({ label: y.label, value: y.value }))
														.find((y) => y?.value == data?.establishmentYear)}
													onChange={(e) => {
														setData({ ...data, establishmentYear: e.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
												/>
											)
										}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('company-detail.activities')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('company-detail.activities')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>

													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<Select
													className="rs-container-est-white-client"
													classNamePrefix="rs"
													isSearchable={true}
													name="customer"
													options={activities}
													value={activities.find((option) => option.value === data.companyActivites)}
													onChange={(e) => {
														setData({ ...data, companyActivites: e.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
												/>
											)
										}
									</td>
								</tr>

								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('company-detail.annual-turnover')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('company-detail.annual-turnover')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<Select
													className="rs-container-est-white-client"
													classNamePrefix="rs"
													isSearchable={true}
													name="turnOver"
													options={turnOver?.map((item) => ({
														label: item.name,
														value: item.id
													}))}
													value={turnOver
														?.map((item) => ({ label: item.name, value: item.id }))
														?.find((item) => item?.value == data?.companyTurnOver)}
													onChange={(e) => {
														setData({ ...data, companyTurnOver: e.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
													menuPlacement="auto"
													menuPosition="fixed"
												/>
											)
										}
									</td>
								</tr>
							</tbody>
						</table>
						<table className="projectmix-table-vertical-client">
							<tbody>
								<tr>
									{!isMobile && <th></th>}

									<td className="fw-600" style={{ textAlign: isMobile ? 'left' : 'left', fontSize: isMobile ? 16 : 14 }}>
										{t('contact-person.contact-person')}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('contact-person.sales-contact')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('contact-person.sales-contact')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<input
													type="text"
													className="form-control"
													value={data?.contactPerson}
													onChange={(e) => {
														setData({ ...data, contactPerson: e.target.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
												/>
											)
										}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('contact-person.company-email')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('contact-person.company-email')}</label>
												)
											)
										}

										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<input
													type="text"
													className="form-control"
													value={data?.email}
													onChange={(e) => {
														setData({ ...data, email: e.target.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
												/>
											)
										}
									</td>
								</tr>

								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('contact-person.phone-number')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('contact-person.phone-number')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div className="phn-cmpny-dtls">
													<PhoneInput
														international
														defaultCountry={selectedCountry}
														value={data?.phonecode ? `+${data.phonecode}${data?.phone}` : data?.phone}
														
														onCountryChange={(country) => {
															setSelectedCountry(country);
														}}
														onChange={(phone) => {
															if (typeof phone === 'string') {
																const phoneNumber = parsePhoneNumberFromString(phone);
																if (phoneNumber) {
																	const phoneCode = phoneNumber.countryCallingCode;
																	setPhoneNumber(phoneNumber);
																	changeSelectedCountry(phoneCode);
																} else {
																	setData({ ...data, phone: '', phonecode: '' });
																}
															} else {
																setData({ ...data, phone: '', phonecode: '' });
															}
														}}
														style={{ width: '100%' }}
														showCountrySelect
														inputClassName="borderRadiusStyle"
														selectClassName="borderRadiusStyle"
													/>
														
												</div>
											)
										}

									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('contact-person.whatsapp-number')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('contact-person.whatsapp-number')}</label>
												)
											)
										}

										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div className="phn-cmpny-dtls">
													<PhoneInput
														international
														defaultCountry={selectedWhatsappCountry}
														value={data?.whatsappcode ? `+${data.whatsappcode}${data?.whatsapp}` : data?.whatsapp}
														onCountryChange={(country) => {
															setSelectedWhatsappCountry(country);
														}}
														onChange={(phone) => {
															if (typeof phone === 'string') {
																const whatsapp = parsePhoneNumberFromString(phone);
																if (whatsapp) {
																	const phoneCode = whatsapp.countryCallingCode;
																	setWhatsapp(whatsapp);
																	changeSelectedCountry(phoneCode);
																} else {
																	setData({ ...data, whatsappcode: '', whatsapp: '' });
																}
															} else {
																setData({ ...data, whatsappcode: '', whatsapp: '' });
															}
														}}
														style={{ width: '100%' }}
														showCountrySelect
													/>
												</div>
											)
										}
									</td>
								</tr>
								<tr>
									{
										!isMobile && (
											<th>
												{
													isPageLoading ? (
														<div>
															<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														t('contact-person.website')
													)
												}
											</th>
										)
									}
									<td>
										{
											isMobile && (
												isPageLoading ? (
													<div style={{ width: '150px' }}>
														<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<label className="onboard-label">{t('contact-person.website')}</label>
												)
											)
										}
										{
											isPageLoading ? (
												<div style={{ padding: '4px 0'}}>
													<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<input
													type="text"
													className="form-control"
													value={data?.website}
													onChange={(e) => {
														setData({ ...data, website: e.target.value });
														const completionPercentage = calculateCompletionPercentage();
													}}
												/>
											)
										}

									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="action-company-dtls-btn" style={{ marginTop: 10 }}>
					{
						isPageLoading ? (
							<div style={{ width: '102px' }}>
								<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
							</div>
						) : (
							<button
								className={`btn btn-cmpny-dtls-action ${isFormProcessing ? 'disabled' : ''}`}
								disabled={isFormProcessing}
								onClick={() => {
									if (isFormProcessing) return;
									setIsFormProcessing(true)
									setIsInProgress(true);
									savePhones();
								}}
							>
								{
									isFormProcessing ? (
										<div><FaSpinner className='spinner' style={{ height: '18px' }} /> <span style={{ marginLeft: '-7px' }}>Please wait...</span></div>
									) : (
										<>
											{t('contact-person.next')} <MdKeyboardArrowRight />
										</>
									)
								}
																									
								
							</button>
						)
					}
				</div>
			</>
		</div>
	);
};

export default CompanyDetails;
